import { z } from 'zod'

export const WORK_TASK_TRACKER_STEP_CONTRACT_VERSION = '1.0.0' as const
export const workTaskTrackerStepResponseSchema = z.unknown()
export type WorkTaskTrackerStepResponse = z.infer<typeof workTaskTrackerStepResponseSchema>
